import React from 'react'
import { Button } from 'antd'

import {
  API_BASE_URL,
} from 'configs/AppConfig'

const getImageUrl = (
  url,
  apiBaseUrl,
) => {
  if (!url) {
    return null
  }

  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('data:') ||
    url.startsWith('blob:')
  ) {
    return url
  }

  const baseUrl =
    apiBaseUrl ||
    API_BASE_URL

  return `${baseUrl}${url}`
}

const getLogoPositionStyle = (
  game,
) => {
  const vertical =
    game.logoVerticalPosition ||
    'TOP'

  const horizontal =
    game.logoHorizontalPosition ||
    'CENTER'

  const style = {
    position: 'absolute',
    zIndex: 10,
  }

  if (
    vertical === 'BOTTOM'
  ) {
    style.bottom = 48
  } else {
    style.top = 48
  }

  if (
    horizontal === 'LEFT'
  ) {
    style.left = 48
  } else if (
    horizontal === 'RIGHT'
  ) {
    style.right = 48
  } else {
    style.left = '50%'
    style.transform =
      'translateX(-50%)'
  }

  return style
}

const RouletteResult = ({
  game,
  prize,
  redirecting,
  hasAfterForm,
  onContinue,
  apiBaseUrl,
}) => {
  const backgroundUrl =
    game.prizePageBackgroundUrl ||
    game.backgroundUrl

  const logoUrl =
    game.prizePageLogoUrl ||
    game.logoUrl

  const frameUrl =
    game.prizePageFrameUrl

  const titleFontSize =
    Number(
      game.prizePageTitleFontSize ||
      76,
    )

  const titleFontWeight =
    game.prizePageTitleFontWeight ||
    '950'

  const titleSpacing =
    Number(
      game.prizePageTitleSpacing ??
      24,
    )

  const subtitleFontSize =
    Number(
      game.prizePageSubtitleFontSize ||
      48,
    )

  const subtitleFontWeight =
    game.prizePageSubtitleFontWeight ||
    '900'

  const subtitleSpacing =
    Number(
      game.prizePageSubtitleSpacing ??
      14,
    )

  const prizeNameFontSize =
    Number(
      game.prizePagePrizeNameFontSize ||
      84,
    )

  const prizeNameFontWeight =
    game.prizePagePrizeNameFontWeight ||
    '950'

  const prizeTextTransform =
    game.prizePagePrizeTextTransform ||
    'uppercase'

  const externalRedirectEnabled =
    game.externalRedirectEnabled ===
    true &&
    Boolean(
      game.externalRedirectUrl,
    )

  const externalRedirectMode =
    String(
      game.externalRedirectMode ||
      'BUTTON',
    ).toUpperCase()

  const externalButtonMode =
    externalRedirectEnabled &&
    externalRedirectMode ===
    'BUTTON'

  const buttonText =
    hasAfterForm
      ? 'Continuar cadastro'
      : externalButtonMode
        ? (
          game.externalRedirectButtonText ||
          'Continuar'
        )
        : 'Próximo participante'

  return (
    <div
      style={{
        width: '100vw',

        height: '100vh',

        minHeight: '100dvh',

        background:
          backgroundUrl
            ? `url(${getImageUrl(
              backgroundUrl,
              apiBaseUrl,
            )}) center/cover no-repeat`
            : '#050505',

        overflow: 'hidden',

        position: 'relative',

        color: '#ffffff',
      }}
    >
      {logoUrl && (
        <div
          style={
            getLogoPositionStyle(
              game,
            )
          }
        >
          <img
            src={getImageUrl(
              logoUrl,
              apiBaseUrl,
            )}
            alt="Logo"
            draggable={false}
            style={{
              maxWidth:
                Number(
                  game.prizePageLogoSize ||
                  game.logoSize ||
                  220,
                ),

              maxHeight:
                Number(
                  game.prizePageLogoSize ||
                  game.logoSize ||
                  220,
                ),

              objectFit:
                'contain',

              userSelect:
                'none',
            }}
          />
        </div>
      )}

      <div
        style={{
          width: '100%',

          height: '100%',

          display: 'flex',

          alignItems: 'center',

          justifyContent:
            'center',

          padding: '8vh 5vw',

          boxSizing:
            'border-box',
        }}
      >
        <div
          style={{
            width:
              'min(82vw, 900px)',

            height:
              'min(82vw, 900px)',

            maxHeight:
              '72vh',

            position:
              'relative',

            display:
              'flex',

            alignItems:
              'center',

            justifyContent:
              'center',

            marginTop:
              '6vh',
          }}
        >
          {frameUrl && (
            <img
              src={getImageUrl(
                frameUrl,
                apiBaseUrl,
              )}
              alt=""
              draggable={false}
              style={{
                position:
                  'absolute',

                inset: 0,

                width:
                  '100%',

                height:
                  '100%',

                objectFit:
                  'contain',

                zIndex: 1,

                userSelect:
                  'none',

                pointerEvents:
                  'none',
              }}
            />
          )}

          <div
            style={{
              position:
                'relative',

              zIndex: 2,

              width:
                '68%',

              height:
                '68%',

              borderRadius:
                '50%',

              background:
                frameUrl
                  ? 'transparent'
                  : 'rgba(255, 132, 0, 0.96)',

              display:
                'flex',

              flexDirection:
                'column',

              alignItems:
                'center',

              justifyContent:
                'center',

              padding:
                '5%',

              boxSizing:
                'border-box',

              textAlign:
                'center',

              overflow:
                'hidden',
            }}
          >
            <div
              style={{
                color:
                  game.prizePageTitleColor ||
                  '#fff200',

                fontSize:
                  `clamp(24px, 5.2vw, ${titleFontSize}px)`,

                fontWeight:
                  titleFontWeight,

                lineHeight:
                  1,

                textAlign:
                  'center',

                textTransform:
                  'uppercase',

                marginBottom:
                  titleSpacing,

                maxWidth:
                  '100%',

                overflowWrap:
                  'break-word',
              }}
            >
              {game.prizePageTitle ||
                'PARABÉNS!'}
            </div>

            <div
              style={{
                color:
                  game.prizePageSubtitleColor ||
                  '#00a6c8',

                fontSize:
                  `clamp(18px, 3.2vw, ${subtitleFontSize}px)`,

                fontWeight:
                  subtitleFontWeight,

                lineHeight:
                  1,

                textAlign:
                  'center',

                textTransform:
                  'uppercase',

                marginBottom:
                  subtitleSpacing,

                maxWidth:
                  '100%',

                overflowWrap:
                  'break-word',
              }}
            >
              {game.prizePageSubtitle ||
                'VOCÊ GANHOU'}
            </div>

            {game.showPrizeImage !==
              false &&
              game.prizePageShowPrizeImage !==
              false &&
              prize?.imageUrl && (
                <img
                  src={getImageUrl(
                    prize.imageUrl,
                    apiBaseUrl,
                  )}
                  alt={
                    prize.name ||
                    'Prêmio'
                  }
                  draggable={false}
                  style={{
                    maxWidth:
                      '42%',

                    maxHeight:
                      '28%',

                    objectFit:
                      'contain',

                    marginBottom:
                      subtitleSpacing,

                    filter:
                      'drop-shadow(0 8px 10px rgba(0,0,0,.35))',

                    userSelect:
                      'none',
                  }}
                />
              )}

            <div
              style={{
                color:
                  game.prizePagePrizeNameColor ||
                  '#fff200',

                fontSize:
                  `clamp(22px, 5.5vw, ${prizeNameFontSize}px)`,

                fontWeight:
                  prizeNameFontWeight,

                lineHeight:
                  0.95,

                textAlign:
                  'center',

                textTransform:
                  prizeTextTransform,

                wordBreak:
                  'break-word',

                overflowWrap:
                  'break-word',

                maxWidth:
                  '100%',

                maxHeight:
                  '38%',

                overflow:
                  'hidden',
              }}
            >
              {prize?.name ||
                'BRINDE'}
            </div>

            <Button
              type="primary"
              size="large"
              loading={
                redirecting
              }
              onClick={
                onContinue
              }
              style={{
                marginTop:
                  32,

                minWidth:
                  240,

                height:
                  56,

                fontSize:
                  18,

                fontWeight:
                  800,

                background:
                  game.primaryColor ||
                  '#7c3aed',

                borderColor:
                  game.primaryColor ||
                  '#7c3aed',

                borderRadius:
                  8,

                boxShadow:
                  'none',
              }}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RouletteResult